'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parcels = require('parcels');

var _parcels2 = _interopRequireDefault(_parcels);

var _PureParcelEquals = require('./util/PureParcelEquals');

var _PureParcelEquals2 = _interopRequireDefault(_PureParcelEquals);

var _shallowEquals = require('unmutable/lib/shallowEquals');

var _shallowEquals2 = _interopRequireDefault(_shallowEquals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PureParcel = function (_React$Component) {
    (0, _inherits3.default)(PureParcel, _React$Component);

    function PureParcel(props) {
        (0, _classCallCheck3.default)(this, PureParcel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PureParcel.__proto__ || (0, _getPrototypeOf2.default)(PureParcel)).call(this, props));

        _this.changeCount = 0;

        _this.debugRenderStyle = function () {
            var rand = function rand() {
                return Math.floor((Math.random() * 0.75 + 0.25) * 256);
            };
            return {
                backgroundColor: 'rgb(' + rand() + ',' + rand() + ',' + rand() + ')',
                padding: "1rem",
                marginBottom: "1rem"
            };
        };

        _this.getParcel = function () {
            var _this$props$debounce = _this.props.debounce,
                debounce = _this$props$debounce === undefined ? 0 : _this$props$debounce;


            if (!debounce) {
                return _this.props.parcel;
            }

            return _this.state.parcel.modifyChange(function (parcel, changeRequest) {

                _this.setState({
                    parcel: parcel._create({
                        parcelData: changeRequest.data()
                    })
                });

                var shouldBeSynchronous = changeRequest.actions().some(function (action) {
                    return action.shouldBeSynchronous();
                });

                _this.changeCount++;
                var originalChangeCount = _this.changeCount;
                if (shouldBeSynchronous) {
                    parcel.dispatch(changeRequest);
                    return;
                }

                setTimeout(function () {
                    if (originalChangeCount === _this.changeCount) {
                        parcel.dispatch(changeRequest);
                    }
                }, debounce);
            });
        };

        _this.state = {
            parcel: props.parcel
        };
        return _this;
    }

    (0, _createClass3.default)(PureParcel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var parcelDataChanged = nextProps.debounce ? !(0, _PureParcelEquals2.default)(this.state.parcel, nextState.parcel) : !(0, _PureParcelEquals2.default)(this.props.parcel, nextProps.parcel);

            var forceUpdateChanged = !(0, _shallowEquals2.default)(this.props.forceUpdate || [])(nextProps.forceUpdate || []);
            return parcelDataChanged || forceUpdateChanged;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var parcel = nextProps.parcel;

            if (!(0, _PureParcelEquals2.default)(this.props.parcel, parcel)) {
                this.setState({
                    parcel: parcel
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;

            var parcel = this.getParcel();
            var element = children(parcel);

            if (parcel._treeshare.getDebugRender()) {
                return _react2.default.createElement(
                    'div',
                    { style: this.debugRenderStyle() },
                    element
                );
            }
            return element;
        }
    }]);
    return PureParcel;
}(_react2.default.Component);

exports.default = PureParcel;


//////////////////
// WEBPACK FOOTER
// ./~/parcels-react/lib/PureParcel.js
// module id = 732
// module chunks = 35783957827783